import { DEFAULT_ROLES } from './defaultRoles';
import type { Persona } from './types';
import { CURRENT_PERSONA_SCHEMA_VERSION } from './types';

export const getPersonaLabel = (personas: Persona[], personaId: string): string =>
  personas.find((persona) => persona.id === personaId)?.label ?? personaId;

export const getPersonaLens = (personas: Persona[], personaId: string): string | undefined =>
  personas.find((persona) => persona.id === personaId)?.lens;

const runCorePersona = (runPersonaId: string): Persona => {
  const builtIn = DEFAULT_ROLES.find((persona) => persona.id === runPersonaId);
  if (builtIn) return { ...builtIn, isCore: true };

  return {
    version: CURRENT_PERSONA_SCHEMA_VERSION,
    id: runPersonaId,
    label: runPersonaId,
    headline: '',
    lens: '',
    recommendationStyle: '',
    discoveryHints: '',
    relevanceNotes: '',
    avoid: '',
    isCore: true,
  };
};

/**
 * What the switcher offers: the configured roles, plus the role the run was authored as when it is
 * no longer one of them — otherwise the core voice would have no tab and the page would show an
 * empty switcher. The run's own role is trusted over the current config, because changing the core
 * role must not re-attribute a run that was already written.
 */
export const personasForRun = (personas: Persona[], runPersonaId: string): Persona[] =>
  personas.some((persona) => persona.id === runPersonaId)
    ? personas
    : [runCorePersona(runPersonaId), ...personas];
